// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { InputBase, IconButton, Box } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import useTranslation from "next-translate/useTranslation";
import { useTheme } from "@mui/material/styles";

import { Grid } from "@/components/core";

export function SearchBar({ value, onChange, sx }: any) {
  const { t } = useTranslation("common");
  const theme = useTheme();

  return (
    <Box
      sx={{
        mx: 1,
        mb: 1,
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 3,
        backgroundColor: theme.components.MuiCssBaseline.styleOverrides.body.backgroundColor,
        ...sx,
      }}
    >
      <Grid wrap="nowrap">
        <Grid.Item xs={10}>
          <InputBase
            autoFocus
            sx={{ mx: 1, width: "100%" }}
            placeholder={t("search")}
            inputProps={{ "aria-label": "search google maps" }}
            value={value}
            onChange={({ target }: any) => {
              onChange(target.value);
            }}
          />
        </Grid.Item>
        <Grid.Item>
          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <SearchIcon />
          </IconButton>
        </Grid.Item>
      </Grid>
    </Box>
  );
}

SearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  sx: PropTypes.object,
};
